import React from 'react';
import { I18n } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';
import config from 'src/config/app.conf';

export const t = key => {
  return <I18n>{translate => ReactHtmlParser(translate(key))}</I18n>;
};

export const getBaseLocaleURL = i18n => {
  return i18n.language === config.defaultLocale ? '' : `/${i18n.language}`;
}



// WEBPACK FOOTER //
// ./src/utils/translate.js